import React from 'react';
import { Col } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { string } = proptypes;

/*
  This regex removes:
    - Microsoft Word-specific styles and classes (starting with mso) from copy-pastes
    - Tags other than p, li, ul, br, a, and div to remove copy-paste clutter and avoid HTML script injection
*/
// eslint-disable-next-line max-len
const descriptionRegex = /\s?(style|class)="[Mm]so([^"]*)"|<[\s]*(?!(li|div|p|a|ul|br|\/))[^>]*>|<\/(?!(li|div|p|a|ul|br))[^>]*>/g;

export const VendorCollectionDescription = ({ description }) => {
  return (
    <Col className="vendor-collection__description" flatten>
      {/* eslint-disable react/no-danger */}
      <div
        data-testid="vendor-collection-description"
        dangerouslySetInnerHTML={{ __html: description?.replace(descriptionRegex, '') }}
      />
    </Col>
  );
};

VendorCollectionDescription.displayName = 'VendorCollectionDescription';

VendorCollectionDescription.propTypes = {
  description: string.isRequired
};